export const Hidden = (props) => {
    const { name, value } = props;
    return (
        <input type="hidden" name={name} defaultValue={value} />
    )
}